import React, { useState } from "react";
import Layout from "../Common/Layout";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import Tesseract from "tesseract.js";

// Use local pdf.worker.js in public folder
pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.js";

const Do = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [extractedText, setExtractedText] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  // Convert PDF page to image for OCR
  const pdfPageToImage = async (page) => {
    const viewport = page.getViewport({ scale: 3 }); // higher scale for better OCR
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    // White background improves OCR accuracy
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    await page.render({ canvasContext: ctx, viewport }).promise;

    return canvas.toDataURL("image/png");
  };

  const extractTextFromPdf = async (file) => {
    setLoading(true);
    try {
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);

        // Only use OCR for image-based pages
        const imageData = await pdfPageToImage(page);
        const result = await Tesseract.recognize(imageData, "eng", {
          logger: (m) => console.log(`Page ${i}:`, m),
          tessedit_pageseg_mode: Tesseract.PSM.SINGLE_BLOCK, // optimize for block of text
        });

        fullText += (result.data.text || "").trim() + "\n";
      }

      if (!fullText.trim()) {
        setExtractedText("");
        toast.error(
          "Could not extract text from this PDF. Please use Manual Data Entry of Do."
        );
        return false;
      }

      setExtractedText(fullText.trim());
      return true;
    } catch (error) {
      console.error("OCR/Text Extraction Error:", error);
      toast.error(
        "Failed to extract text from PDF. Please use Manual Data Entry of Do."
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.file) {
      const ok = await extractTextFromPdf(formData.file);
      if (ok) {
        toast.success("✅ PDF processed successfully!", {
          position: "top-right",
          autoClose: 2000,
          theme: "colored",
        });
      }
    } else {
      toast.error("Please upload a PDF file first.");
    }
  };

  return (
    <Layout>
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row justify-content-center mt-4">
              <div className="col-xxl-6 col-lg-8 col-md-10">
                <div className="card shadow-sm border-0 rounded-3">
                  <div
                    className="card-body p-4"
                    style={{
                      backgroundColor: "#0F71AD",
                      color: "white",
                      borderRadius: "10px",
                    }}
                  >
                    <h4 className="card-title mb-4 text-center fw-semibold">
                      Upload PDF of Delivery Order
                    </h4>

                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label
                          htmlFor="file"
                          className="form-label fw-semibold"
                        >
                          Upload Kata Slip
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          id="file"
                          name="file"
                          accept="application/pdf"
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="container">
                        <div className="row">
                          <div className="col-lg-6 text-center">
                            <button
                              type="submit"
                              className="btn px-5 py-2 fw-semibold"
                              disabled={loading}
                              style={{
                                backgroundColor: "#EC662C",
                                color: "white",
                              }}
                            >
                              {loading
                                ? "Processing..."
                                : "Upload Delivery Order"}
                            </button>
                          </div>
                          <div className="col-lg-6 text-center">
                            <Link
                              role="button"
                              className="btn px-5 py-2 fw-semibold"
                              to="/do-form"
                              style={{
                                backgroundColor: "#EC662C",
                                color: "white",
                              }}
                            >
                              Manual Data Entry of Do
                            </Link>
                          </div>
                        </div>
                      </div>
                    </form>

                    {extractedText && (
                      <>
                        <div className="mt-4">
                          <h5 className="fw-semibold">Extracted Text:</h5>
                          <pre
                            className="p-3 border rounded bg-light"
                            style={{ whiteSpace: "pre-wrap" }}
                          >
                            {extractedText}
                          </pre>
                        </div>
                        <div className="mt-3 text-center">
                          <button
                            type="button"
                            className="btn btn-success fw-semibold"
                            onClick={() => navigate("/do-form")}
                          >
                            Use This Data in DO Form
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
    </Layout>
  );
};

export default Do;
